import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";
import upcomingBirthdayInterface from "../../infra/aggregates/UpcomingBirthdayInterface";
// Define a type for the slice state

// Define the initial state using that type

const upcomingBirthdaySlice = createSlice({
  name: "upcomingBirthday",

  initialState: { birthday: [] },
  reducers: {
    upcomingBirthdayReducer: (
      state: any,
      action: PayloadAction<upcomingBirthdayInterface[]>
    ) => {
      state.birthday = action.payload;
    },
    resetUpcomingBirthday: (state: any) => {
      state.birthday = [];
    },
  },
});

export const { upcomingBirthdayReducer, resetUpcomingBirthday } =
  upcomingBirthdaySlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default upcomingBirthdaySlice.reducer;
